/** A record name that deep-links into the Contracts section when an id is
 *  available; otherwise plain text. Stops row-click propagation. */
export function RecordLink({
  label,
  onOpen,
}: {
  label: string;
  onOpen?: (() => void) | false | null;
}) {
  if (!onOpen) return <span>{label}</span>;
  return (
    <button
      type="button"
      onClick={(e) => {
        e.stopPropagation();
        onOpen();
      }}
      className="text-left font-medium text-brand hover:underline"
      title="Open in Contracts"
    >
      {label}
    </button>
  );
}
